export const GROUP_BUDGET = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  VOIDED: 'voided',
};

export const SUBSCRIPTION = {
  ACTIVE: 'active',
  PENDING: 'pending',
  PENDING_CANCEL: 'pending_cancel',
  CANCELLED: 'cancelled',
};

export const REIMBURSEMENT = {
  APPROVED: 'approved',
  REJECTED: 'rejected',
  PENDING: 'pending',
  RECURRING: 'in_progress',
  COMPLETED: 'completed',
};

export const TRANSACTION = {
  CONFIRMED: 'confirmed',
  CANCELLED: 'cancelled',
  FULFILLED: 'fulfilled',
  PROCESSING: 'processing',
  PENDING: 'pending',
  SHIPPED: 'shipped',
};
